/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Id_TakenInputs */



/**
* | output |
* | --- |
* | "A model with this ID already exists in your organization." |
*
* @param {Private_Models_Save_Id_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_id_taken = /** @type {((inputs?: Private_Models_Save_Id_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Id_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Modell mit dieser ID gibt es in Ihrer Organisation bereits.")
	return /** @type {LocalizedString} */ ("A model with this ID already exists in your organization.")
});